interface RecruitmentDetailModalProps {
  recruitmentTitle: string;
  onClose: () => void;
}

const RecruitmentDetailModal = ({
  recruitmentTitle,
  onClose,
}: RecruitmentDetailModalProps) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="gradient-bg text-white p-6 rounded-t-xl">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold">{recruitmentTitle}</h2>
              <p className="opacity-90">The Rockers</p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                  募集中
                </span>
                <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                  応募5件
                </span>
              </div>
              <p className="text-sm text-gray-500">投稿日: 2024/02/20</p>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">🎸</span>
                バンド情報
              </h3>
              <div className="space-y-3 bg-gray-50 p-4 rounded-lg">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">バンド名</span>
                  <span className="font-medium">The Rockers</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">ジャンル</span>
                  <span className="font-medium">ロック</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">結成年</span>
                  <span className="font-medium">2022年</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">現在のメンバー</span>
                  <span className="font-medium">4人</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">活動エリア</span>
                  <span className="font-medium">東京都内</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">ライブ経験</span>
                  <span className="font-medium">月2-3回</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">練習場所</span>
                  <span className="font-medium">渋谷・新宿近辺</span>
                </div>
                <div className="pt-2 border-t border-gray-200">
                  <span className="text-sm text-gray-600">バンド紹介</span>
                  <p className="text-sm mt-1">
                    2022年に結成したロックバンド。オリジナル楽曲中心に活動し、月2-3回のライブ出演を目標としています。メンバー全員が音楽に情熱を注いでおり、共に成長できる仲間を探しています。
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">📝</span>
                募集内容
              </h3>
              <p className="text-gray-700 bg-gray-50 p-3 rounded-lg">
                週末中心の活動で、ライブハウスでの演奏を目指しています。初心者歓迎！音楽を楽しみながら一緒に成長していきましょう。現在4人で活動しており、ドラマーが加わることで本格的なライブ活動を開始予定です。
              </p>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">🎯</span>
                募集条件
              </h3>
              <div className="space-y-2 text-sm">
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>募集ポジション</span>
                  <span className="font-medium">ドラム</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>スキルレベル</span>
                  <span className="font-medium">初心者OK</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>活動頻度</span>
                  <span className="font-medium">週1-2回</span>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span>年齢</span>
                  <span className="font-medium">20-35歳</span>
                </div>
              </div>
            </div>

            <div>
              <h3 className="font-semibold mb-3 flex items-center">
                <span className="mr-2">👥</span>
                応募者一覧 (5件)
              </h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold mr-3">
                      IK
                    </div>
                    <div>
                      <h4 className="font-medium">伊藤健太</h4>
                      <p className="text-xs text-gray-600">ドラム歴3年</p>
                    </div>
                  </div>
                  <div className="flex space-x-2">
                    <button className="text-blue-500 text-sm hover:underline">
                      詳細
                    </button>
                    <button className="text-green-500 text-sm hover:underline">
                      承認
                    </button>
                  </div>
                </div>
                <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-gradient-to-r from-green-400 to-blue-400 rounded-full flex items-center justify-center text-white font-bold mr-3">
                      KS
                    </div>
                    <div>
                      <h4 className="font-medium">加藤翔太</h4>
                      <p className="text-xs text-gray-600">ドラム歴1年</p>
                    </div>
                  </div>
                  <div className="flex space-x-2">
                    <button className="text-blue-500 text-sm hover:underline">
                      詳細
                    </button>
                    <button className="text-green-500 text-sm hover:underline">
                      承認
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex space-x-3 mt-6">
            <button
              onClick={onClose}
              className="flex-1 py-3 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
            >
              閉じる
            </button>
            <button className="flex-1 bg-red-500 text-white py-3 rounded-lg font-medium hover:bg-red-600 transition-colors">
              募集を終了
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecruitmentDetailModal;
